import store from '@state/store'
import router from '@router'

export default function routeError(error, routeTo, callback) {
  console.log('TCL: Route -> error', error);

  if(error.code === 405 || error.code === 401) {
    const merchantAlias = getMerchentAlias();

    store.dispatch('auth/logOut');

    window.location = `/${merchantAlias}/login?redirectFrom=${routeTo.path}`;
  }else {
    return callback
  }
}

function getMerchentAlias() {
  const routeMerchentAlias = router ? router.currentRoute.params.merchantAlias : false;
  const pathMerchentAlias = window.location.pathname.split('/')[1];

  return routeMerchentAlias || (pathMerchentAlias !== '404' ? pathMerchentAlias : false) || false
}
